import React, { useEffect, useState, useMemo } from "react";
import axios from "../context/axiosConfig";
import requireAuth from "../context/requireAuth";
import MaterialReactTable from 'material-react-table';
import { Box, Button, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DeleteIcon from '@mui/icons-material/FileDownload';

import { ExportToCsv } from 'export-to-csv';
  
function Product() {

    const org_id = localStorage.getItem("organization");

    const [product, setProduct] = useState([]);
    const [showOnlyActive, setShowOnlyActive] = useState(true);
    const [showOnlyDestroyed, setShowOnlyDestroyed] = useState(false);
    useEffect(() => {
        axios.get(`orgs/${org_id}/products/`, { withCredentials: true })
            .then(res => setProduct(res.data))
            .catch(err => console.log(err));
    }, []);

    // const [countAll, setCountAll] = useState([]);
    // useEffect(() => {
    //     axios.get("product/count")
    //         .then(res => setCountAll(res.data))
    //         .catch(err => console.log(err));
    // }, []);

    const [countGramInHouse, setCountGram] = useState([]);
    useEffect(() => {
        axios.get(`orgs/${org_id}/products/count/quantity/inhouse`, { withCredentials: true })
            .then(res => setCountGram(res.data))
            .catch(err => console.log(err));
    }, []);

    const [countGramDry, setCountGramDry] = useState([]);
    useEffect(() => {
        axios.get(`orgs/${org_id}/products/count/quantity/dry`, { withCredentials: true })
            .then(res => setCountGramDry(res.data))
            .catch(err => console.log(err));
    }, []);

    const [countGramFresh, setCountGramFresh] = useState([]);
    useEffect(() => {
        axios.get(`orgs/${org_id}/products/count/quantity/fresh`, { withCredentials: true })
            .then(res => setCountGramFresh(res.data))
            .catch(err => console.log(err));
    }, []);

    const columns = useMemo(
        () => [
          {
            accessorKey: 'org_product_no',
            header: 'Product ID',
          },
          {
            accessorKey: 'name',
            header: 'Name',
          },
          {
            accessorKey: 'datecreated',
            header: 'Date Created',
            Cell: ({ cell }) => {
              const date = cell.row.original.datecreated;
              return date ? new Date(date).toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
              }) : 'NO DATE';
            }
          },
          {
            accessorKey: 'datedestroyed',
            header: 'Date Destroyed',
            Cell: ({ cell }) => {
              const date = cell.row.original.datedestroyed;
              return date ? new Date(date).toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
              }) : 'NO DATE';
            }
          },
          {
            accessorKey: 'quantity',
            header: 'Quantity (g)',
          },
          {
            accessorKey: 'fresh',
            header: 'Fresh (Y/N)',
          },
          {
            accessorKey: 'dry',
            header: 'Dry (Y/N)',
          },
          {
            accessorKey: 'location',
            header: 'Location (Room)',
          },
          {
            accessorKey: 'remark',
            header: 'Remark',
          },
        ],
        [],
      );
      

    const csvOptions = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        useBom: true,
        useKeysAsHeaders: true,
        fields: columns.map((c) => c.header),
      };
      
      const csvExporter = new ExportToCsv(csvOptions);
      
      const handleExportRows = (rows) => {
        csvExporter.generateCsv(rows.map((row) => row.original));
      };
      
      const handleExportData = () => {
        csvExporter.generateCsv(filteredProducts);
      };

      const handleDeleteProduct = (rows) => {
        // console.log(JSON.stringify(rows));
        // console.log(JSON.stringify(rows.map((row)=> row.original)));
        const body = {};
        body[`ids`] = rows.map((row) => row.original.product_id);
      
            axios.post(`orgs/${org_id}/products/deleteproducts`, body, { withCredentials: true })
            .then(response => {
              console.log(response.data);
              alert(`product(s) deleted`);
              window.location.reload();
            })
            .catch(error => {
              console.error(error);
            });
      };

      // Filter products based on checkbox states
      const filteredProducts = useMemo(() => {
        let filtered = product;

        if (showOnlyActive) {
          filtered = filtered.filter(p => !p.datedestroyed);
        }

        if (showOnlyDestroyed) {
          filtered = filtered.filter(p => p.datedestroyed);
        }

        return filtered;
      }, [product, showOnlyActive, showOnlyDestroyed]);

    return (
        <div className="bodyContent">
            <label htmlFor="plants" className="subheader">Select Products</label>

            <div className="plantData">
                <div className="value">
                    <div className="purpleHeader">
                        <p className="valueTitle">Quantity Inhouse (g)</p>
                    </div>
                    <div className="valueBox">
                        <p className="valueText">{countGramInHouse.totalGrams}</p>
                    </div>
                </div>
            </div>

            {/* Filtering Controls */}
            <div style={{ marginTop: '1rem', paddingLeft: "20px", display: 'flex', alignItems: 'center', gap: '20px' }}>
                <FormGroup row sx={{ mb: 1 }} style={{ marginTop: '20px', marginLeft: '5px' }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                size="medium"
                                checked={showOnlyActive}
                                onChange={() => {
                                    setShowOnlyActive(prev => !prev);
                                    if (!showOnlyActive) {
                                        setShowOnlyDestroyed(false);
                                    }
                                }}
                                style={{ marginRight: '12px', cursor: 'pointer', transform: 'scale(1.3)' }}
                            />
                        }
                        label={<span style={{ fontSize: '1.15rem', fontWeight: 500 }}>Show only active products</span>}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                size="medium"
                                checked={showOnlyDestroyed}
                                onChange={() => {
                                    setShowOnlyDestroyed(prev => !prev);
                                    if (!showOnlyDestroyed) {
                                        setShowOnlyActive(false);
                                    }
                                }}
                                style={{ marginRight: '12px', cursor: 'pointer', transform: 'scale(1.3)' }}
                            />
                        }
                        label={<span style={{ fontSize: '1.15rem', fontWeight: 500 }}>Show only deleted products</span>}
                    />
                </FormGroup>
            </div>

            <div className="plantTableDiv" style={{ marginTop: "40px" }}>
                <MaterialReactTable columns={columns} data={filteredProducts} enableRowSelection enableColumnOrdering 
                nitialState={{
                  showColumnFilters: true,
                  pagination: { pageIndex: 0, pageSize: 25 },
                  sorting: [{ id: 'org_product_no', desc: true }],   // ← id matches accessorKey
                  columnOrder: ['org_product_no', 'name', 'datecreated', 'datedestroyed',
                                'quantity', 'fresh', 'dry', 'location'], // keep ID first
                }}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{ display: 'flex', gap: '1rem', p: '0.5rem', flexWrap: 'wrap' }}
                    >
                      <Button
                        color="primary"
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        onClick={handleExportData}
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export All Data
                      </Button>
                      <Button
                        disabled={
                          !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export Selected Rows
                      </Button>
                      <Button
                        disabled={
                          !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        onClick={() => handleDeleteProduct(table.getSelectedRowModel().rows)}
                        startIcon={<DeleteIcon />}
                        variant="contained"
                      >
                        Delete Selected Products
                      </Button>
                    </Box>
                  )}
                />
            </div>
        </div>
    )
}

export default requireAuth(Product);